type NativeIOSMessage = {
  command: string;
  value?: string;
};

type NativeAppWindow = Window & {
  LLWebInterface?: {
    sendLogoutEvent?: () => void;
  };
  webkit?: {
    messageHandlers?: {
      LLWebHandler?: {
        postMessage?: (message: NativeIOSMessage) => void;
      };
    };
  };
};

function isNativeApp(): NativeAppWindow | null {
  if (typeof window === 'undefined') {
    return null;
  }

  const nativeWindow = window as NativeAppWindow;
  const hasNativeInterface = nativeWindow.LLWebInterface != null || nativeWindow.webkit?.messageHandlers?.LLWebHandler != null;

  if (!hasNativeInterface) {
    return null;
  }

  return nativeWindow;
}

export { isNativeApp, type NativeIOSMessage };
